import {hasCookieConsentMarketing, hasCookieConsentStatistics, renewCookieConsent} from "../../utils/Utils.js";

const CookieCompliance = () => {

	let digitalinklusion24CookieCatStatistic1stLoad = false;
	let digitalinklusion24CookieCatMarketing1stLoad = false;

	window.addEventListener('CookieInformationConsentGiven', (e) => {
		if(hasCookieConsentStatistics()) {
			const blocksOptoutStatistic = document.querySelectorAll('.cookieconsent-optout-statistic');
			blocksOptoutStatistic.forEach((block) => {
				block.style.display = 'none';
			});
			if(!digitalinklusion24CookieCatStatistic1stLoad) {
				digitalinklusion24CookieCatStatistic1stLoad = true;
			}
		}
		if(hasCookieConsentMarketing()) {
			const blocksOptoutMarketing = document.querySelectorAll('.cookieconsent-optout-marketing');
			blocksOptoutMarketing.forEach((block) => {
				block.style.display = 'none';
			});
			if(!digitalinklusion24CookieCatMarketing1stLoad) {
				digitalinklusion24CookieCatMarketing1stLoad = true;
			}
		}
	}, false);

	document.querySelectorAll('.cookie-compliance-renew').forEach(btn => btn.addEventListener('click', renewCookieConsent));
}

export default CookieCompliance;